import React from 'react'
import TenantsProfilesTable from '../../modules/tenant-profiles/components/TenantProfilesTable'

export default function TenantProfilesPage() {
    return <TenantsProfilesTable />
}
